/* eslint-disable arrow-parens */
/* eslint-disable operator-linebreak */
import _sortBy from 'lodash/sortBy';

// constants
import {
  DESTINATION_CHARGER_RADIUS,
  DESTINATION_CHARGER_UNIT,
  DESTINATION_CHARGER_MARKER,
} from '../../../lib/Constants';

// actions
import { createErrorMsgError } from '../../ErrorMsg/actions';

// helpers
import { makeActionCreator } from '../../../lib/Utils';
import Client from '../../../lib/Client';
import MapUtils from '../../../lib/MapUtils';
import MapMarkers from '../../../lib/MapMarkers';

export const DESTINATIONCHARGERS_FETCH_REQUEST =
  'DESTINATIONCHARGERS_FETCH_REQUEST';
const fetchDestinationChargersRequest = makeActionCreator(
  DESTINATIONCHARGERS_FETCH_REQUEST,
);

export const DESTINATIONCHARGERS_FETCH_SUCCESS =
  'DESTINATIONCHARGERS_FETCH_SUCCESS';
const fetchDestinationChargersSuccess = makeActionCreator(
  DESTINATIONCHARGERS_FETCH_SUCCESS,
  'destinationChargers',
);

export const DESTINATIONCHARGERS_IS_CHARGERS =
  'DESTINATIONCHARGERS_IS_CHARGERS';
export const isDestinationChargers = makeActionCreator(
  DESTINATIONCHARGERS_IS_CHARGERS,
  'isDestinationChargers',
);

export const DESTINATIONCHARGERS_FETCH_FAILURE =
  'DESTINATIONCHARGERS_FETCH_FAILURE';
const fetchDestinationChargersFailure = makeActionCreator(
  DESTINATIONCHARGERS_FETCH_FAILURE,
  'error',
);

export const DESTINATIONCHARGERS_REMOVE_ANIMATION =
  'DESTINATIONCHARGERS_REMOVE_ANIMATION';
export const removeDestinationChargersAnimation = makeActionCreator(
  DESTINATIONCHARGERS_REMOVE_ANIMATION,
  'animationName',
);

export const DESTINATIONCHARGERS_DELETE_CHARGERS =
  'DESTINATIONCHARGERS_DELETE_CHARGERS';
export const deleteDestinationChargers = makeActionCreator(
  DESTINATIONCHARGERS_DELETE_CHARGERS,
);

export const DESTINATIONCHARGERS_TOGGLE_UI = 'DESTINATIONCHARGERS_TOGGLE_UI';
export const toggleDestinationChargersUI = makeActionCreator(
  DESTINATIONCHARGERS_TOGGLE_UI,
  'showDestinationChargers',
);
export function toggleDestinationChargers(showDestinationChargers) {
  return (dispatch, getState) => {
    const { animationTimeout } = getState().DestinationChargers;

    dispatch(toggleDestinationChargersUI(showDestinationChargers));
    dispatch(deleteDestinationChargers());

    // remove animation once it has completed to avoid triggering after a render
    if (!showDestinationChargers) {
      setTimeout(() => {
        dispatch(removeDestinationChargersAnimation(''));
      }, animationTimeout * 10);
    }
  };
}

function sortChargers(fields, fieldsLength, res) {
  const { google } = window;

  // calculate distance from destination pin to destination charger
  const destinationChargers = res.body.responseObject;
  const { lat, lng } = fields[fieldsLength - 1];
  const destination = new google.maps.LatLng(lat, lng);
  const newChargers = destinationChargers.map(charger => {
    const chargerPlot = new google.maps.LatLng(
      charger.geoPoint.lat,
      charger.geoPoint.lon,
    );
    const distance = Math.round(
      MapUtils.distanceBetweenPlots(destination, chargerPlot),
    );
    return Object.assign({}, charger, {
      distance,
    });
  });

  // sort & truncate destination chargers
  const sortedChargers = _sortBy(newChargers, ['distance']).slice(0, 10);

  return sortedChargers;
}

function constructParams(fields, fieldsLength) {
  return {
    distance: DESTINATION_CHARGER_RADIUS,
    location: {
      lat: fields[fieldsLength - 1].lat,
      lon: fields[fieldsLength - 1].lng,
    },
    unitOfDistance: DESTINATION_CHARGER_UNIT,
  };
}

function dispatchFailure({ dispatch, getState, err }) {
  const { somethingWrong } = getState().ErrorMsg.errors;
  dispatch(fetchDestinationChargersFailure(err));
  dispatch(isDestinationChargers(false));
  dispatch(createErrorMsgError(somethingWrong));
}

function removeAnimation({ dispatch, animationTimeout }) {
  setTimeout(() => {
    dispatch(removeDestinationChargersAnimation(''));
  }, animationTimeout * 10);
}

export function fetchDestinationChargers(showDestinationChargers) {
  return (dispatch, getState) => {
    const { animationTimeout, body } = getState().DestinationChargers;
    const { fields, fieldsLength } = getState().Places;
    const { isMobile } = getState().App;
    const zoom = MapUtils.getZoom();

    dispatch(fetchDestinationChargersRequest());

    const params = constructParams(fields, fieldsLength);
    Client.fetchDestinationChargers(params, (err, res) => {
      if (err) {
        dispatchFailure({ dispatch, getState, err });
      } else {
        let sortedChargers = sortChargers(fields, fieldsLength, res);
        dispatch(fetchDestinationChargersSuccess(sortedChargers));

        sortedChargers.map(charger => {
          const coords = {
            id: charger.id,
            lat: charger.geoPoint.lat,
            lng: charger.geoPoint.lon,
          };
          MapMarkers.setDestinationChargerMarker(
            coords,
            zoom,
            body,
            isMobile,
            DESTINATION_CHARGER_MARKER,
          );

          return null;
        });

        // push in destination pin for better zooming
        sortedChargers = sortedChargers.concat([
          {
            geoPoint: {
              lat: fields[fieldsLength - 1].lat,
              lon: fields[fieldsLength - 1].lng,
            },
          },
        ]);
        // zoom map to fit nearest n destination chargers
        MapUtils.fitMapToMarkers(sortedChargers, sortedChargers.length);
      }
    });

    dispatch(toggleDestinationChargersUI(showDestinationChargers));

    // remove animation once it has completed to avoid triggering after a render
    if (!showDestinationChargers) {
      removeAnimation({ dispatch, animationTimeout });
    }
  };
}

export function prefetchDestinationChargers() {
  return (dispatch, getState) => {
    const { fields, fieldsLength } = getState().Places;

    const params = constructParams(fields, fieldsLength);
    Client.fetchDestinationChargers(params, (err, res) => {
      if (err) {
        dispatchFailure({ dispatch, getState, err });
      } else {
        const sortedChargers = sortChargers(fields, fieldsLength, res);
        dispatch(fetchDestinationChargersSuccess(sortedChargers));

        dispatch(isDestinationChargers(sortedChargers.length > 0));
      }
    });
  };
}

export const DESTINATIONCHARGERS_HYDRATE_DATA =
  'DESTINATIONCHARGERS_HYDRATE_DATA';
export const hydrateDestinationChargersData = makeActionCreator(
  DESTINATIONCHARGERS_HYDRATE_DATA,
  'data',
);
